var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBakingcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 24C21.75 25.2426 22.7574 26.25 24 26.25C25.2426 26.25 26.25 25.2426 26.25 24C26.25 22.7574 25.2426 21.75 24 21.75C22.7574 21.75 21.75 22.7574 21.75 24Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7777 30.3259C16.7866 31 18.1911 31 21 31L27 31C29.8089 31 31.2134 31 32.2223 30.3259C32.659 30.034 33.034 29.659 33.3259 29.2223C34 28.2134 34 26.8089 34 24C34 21.1911 34 19.7866 33.3259 18.7777C33.034 18.341 32.659 17.966 32.2223 17.6741C31.2134 17 29.8089 17 27 17H21C18.1911 17 16.7866 17 15.7777 17.6741C15.341 17.966 14.966 18.341 14.6741 18.7777C14 19.7866 14 21.1911 14 24C14 26.8089 14 28.2134 14.6741 29.2223C14.966 29.659 15.341 30.034 15.7777 30.3259ZM24 27.75C21.9289 27.75 20.25 26.0711 20.25 24C20.25 21.9289 21.9289 20.25 24 20.25C26.0711 20.25 27.75 21.9289 27.75 24C27.75 26.0711 26.0711 27.75 24 27.75ZM17.5 27.75C17.0858 27.75 16.75 27.4142 16.75 27L16.75 21C16.75 20.5858 17.0858 20.25 17.5 20.25C17.9142 20.25 18.25 20.5858 18.25 21L18.25 27C18.25 27.4142 17.9142 27.75 17.5 27.75ZM29.75 27C29.75 27.4142 30.0858 27.75 30.5 27.75C30.9142 27.75 31.25 27.4142 31.25 27V21C31.25 20.5858 30.9142 20.25 30.5 20.25C30.0858 20.25 29.75 20.5858 29.75 21V27Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBakingcircle);
export default __webpack_public_path__ + "static/media/bakingcircle.1fbca6aa0b8a6171ba570c9d5a30d8a2.svg";
export { ForwardRef as ReactComponent };